module.exports = __webpack_public_path__ + "facebook.png?d547f795b0645c3fdbed0c961274519b";